export default __webpack_public_path__ + "static/media/satisfaction-gurantee.82355f54.png";